import React, { useRef } from "react";
import PropTypes from "prop-types";
import {
  List,
  ListItem,
  CircularProgress,
  Box,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ExerciseRecord from "./ExerciseRecord";
import { colors } from "../../styles";
import { textStrings } from "../../textStrings";

const useStyles = makeStyles({
  listContainer: {
    overflowY: "auto",
    height: "88%",
    padding: 0,
  },
  exerciseListHeading: {
    border: `1px solid ${colors.divider_line_white}`,
    backgroundColor: colors.checkbox_grey,
    padding: "10px 25px",
  },
  ListHeadingText: {
    fontFamily: "DMSans, sans-serif",
    fontWeight: 500,
    fontSize: 14,
  },
});

function LoadingSpinner() {
  return (
    <ListItem
      key="loading spinner"
      style={{ display: "flex", justifyContent: "center" }}
    >
      <CircularProgress size={20} />
    </ListItem>
  );
}

const ExerciseRecordWithRef = React.forwardRef((props, ref) => {
  return <ExerciseRecord lastExerciseRecordRef={ref} {...props} />;
});
function ExerciseList(props) {
  const classes = useStyles(props);

  const {
    exerciseData,

    currentTab,
    isLoading,
    selectedExerciseId,
    setSelectedExerciseId,
    viewExerciseDetailsLink,
    setIsExerciseDataRefresh,
  } = props;

  const favoriteExercises = exerciseData?.filter(
    (exercise) => exercise?.is_favorite,
  );

  const nonFavoriteExercises = exerciseData?.filter(
    (exercise) => !exercise?.is_favorite,
  );

  const rootElement = useRef();
  


  const renderExerciseList = (exercises) =>
  exercises.map((exercise, index) => (
    <ExerciseRecordWithRef
      ref={
        exercises.length === index + 1 ? props.lastExerciseRecordRef : null
      }
      key={exercise.id}
      value={index}
      isSelected={selectedExerciseId === exercise.id}
      onChangeSelectedExerciseId={setSelectedExerciseId}
      exercise={exercise}
      viewExerciseDetailsLink={viewExerciseDetailsLink}
      setIsExerciseDataRefresh={setIsExerciseDataRefresh}
    />
  ));
  return (
    <List ref={rootElement} className={classes.listContainer}>
      {(favoriteExercises.length > 0 || nonFavoriteExercises?.length > 0) && (
        <>
          {currentTab === "my-exercises" && (
            <Box className={classes.exerciseListHeading}>
              <Typography className={classes.ListHeadingText}>
                {textStrings.myExercises}
              </Typography>
            </Box>
          )}

        {renderExerciseList(favoriteExercises)}
        {renderExerciseList(nonFavoriteExercises)}
        </>
      )}
      {isLoading && <LoadingSpinner />}
    </List>
  );
}

ExerciseList.propTypes = {
  exerciseData: PropTypes.array,
  superSets: PropTypes.array,
  currentTab: PropTypes.string,
  isLoading: PropTypes.bool,
  selectedExerciseId: PropTypes.number,
  setSelectedExerciseId: PropTypes.func,
  viewExerciseDetailsLink: PropTypes.func,
  setIsExerciseDataRefresh: PropTypes.func,
};

export default ExerciseList;
